import type { CSSProperties } from 'react'

export const BUTTON_CONTAINER_STYLE: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  paddingTop: 16,
  marginTop: 16,
  borderTop: '1px solid var(--ant-color-border-secondary)',
}
